var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommentRepository } from '@amityco/js-sdk';
import { useActionEvents } from '../../core/providers/ActionProvider';
import useLiveObject from '../../core/hooks/useLiveObject';
import useMemoAsync from '../../core/hooks/useMemoAsync';
import useUser from '../../core/hooks/useUser';
const useComment = ({ commentId }) => {
    const comment = useLiveObject(() => CommentRepository.commentForId(commentId), [commentId]);
    const isCommentReady = !!comment.commentId;
    const { userId, referenceId, referenceType } = comment;
    const actionEvents = useActionEvents();
    const { user: commentAuthor, file: commentAuthorAvatar } = useUser(userId);
    const isFlaggedByMe = useMemoAsync(() => __awaiter(void 0, void 0, void 0, function* () { return ((comment === null || comment === void 0 ? void 0 : comment.commentId) ? CommentRepository.isFlaggedByMe(comment.commentId) : false); }), [comment]);
    const handleReportComment = () => __awaiter(void 0, void 0, void 0, function* () {
        return isFlaggedByMe ? CommentRepository.unflag(commentId) : CommentRepository.flag(commentId);
    });
    const handleReplyToComment = (replyCommentText, mentionees, metadata, isDisabled) => {
        var _a;
        CommentRepository.createTextComment({
            referenceType,
            referenceId,
            text: replyCommentText,
            parentId: commentId,
            metadata,
            mentionees,
        });
        (_a = actionEvents.onCommentCreate) === null || _a === void 0 ? void 0 : _a.call(actionEvents, {
            isReply: true,
            isDisabled,
        });
    };
    const handleEditComment = (text, mentionees, metadata) => CommentRepository.editTextComment({
        commentId,
        text,
        metadata,
        mentionees,
    });
    const handleDeleteComment = () => {
        CommentRepository.deleteComment(commentId);
    };
    return {
        isCommentReady,
        comment,
        commentAuthor,
        commentAuthorAvatar,
        handleReportComment,
        handleReplyToComment,
        handleEditComment,
        handleDeleteComment,
        isFlaggedByMe,
    };
};
export default useComment;
//# sourceMappingURL=useComment.js.map